<div class="form-group" [formGroup]="parentForm">
  <label class="form-label">Email adresa</label>
  <input type="text"
         class="form-control"
         [class.is-invalid]="f.email.touched && f.email.errors && (f.email.errors.required || f.email.errors.email)"
         formControlName="email"
         name="email"
         placeholder="Email"
         id="email">
  <div class="invalid-feedback"
       *ngIf="f.email.touched && f.email.errors && f.email.errors.required">
    Unesite email adresu
  </div>
  <div class="invalid-feedback"
       *ngIf="f.email.touched && f.email.errors && f.email.errors.email">
    Email nije ispravan
  </div>
</div>